const generateTrackDestination = url => {
  if (!url) return undefined;
  if (url.includes('://')) return url;

  const withoutLocale = url.replace(/^\/[a-z]{2}(-[a-z]{2})?\//i, '/');
  const segments = withoutLocale.split('/').filter(Boolean);
  return ['oc', ...segments].join(' | ');
};

export default generateTrackDestination;
